import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Committee = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    // 渲染委員資訊的函數
    const renderCommitteeInfo = (data) => {
        return data.map((item, index) => {
            if (isMobile) {
                return (
                    <div key={index} className="subtext-row">
                        <div className="name-title">
                            <span>{item.name}</span>
                            <span>{item.title}</span>
                        </div>
                        <div className="affiliation">{item.affiliation}</div>
                    </div>
                );
            } else {
                return (
                    <React.Fragment key={index}>
                        <p className="subtext-item">{item.name}</p>
                        <p className="subtext-item">{item.title}</p>
                        <p className="subtext-item">{item.affiliation}</p>
                    </React.Fragment>
                );
            }
        });
    };

    // 委員會數據
    const committeeData = {
        honorary: { name: '廖婉君', title: '教授', affiliation: '國立臺灣大學 副校長' },
        honoraryVice: { name: '陳全木', title: '教授', affiliation: '國立中興大學 副校長' },
        steering: [
            { name: '林一平', title: '教授', affiliation: '國立陽明交通大學資訊工程學系 終身講座教授' },
            { name: '許健平', title: '教授', affiliation: '國立清華大學資訊工程學系 講座教授' },
            { name: '曾煜棋', title: '教授', affiliation: '國立陽明交通大學資訊工程學系 終身講座教授' }
        ],
        general: [
            { name: '逄愛君', title: '教授', affiliation: '中央研究院資訊科技創新研究中心 特聘研究員兼主任' },
            { name: '蔡清池', title: '教授', affiliation: '國立中興大學電機工程學系 特聘教授/電資學院院長' }
        ],
        program: [
            { name: '巫芳璟', title: '副教授', affiliation: '國立臺灣大學資訊工程學系' },
            { name: '曾學文', title: '教授', affiliation: '國立中興大學資訊工程學系 特聘教授' }
        ],
        publication: [
            { name: '陳彥安', title: '助理教授', affiliation: '元智大學資訊工程學系' },
            { name: 'Edwin Ren Yi', title: '副教授', affiliation: 'University of East Anglia, UK' }
        ],
        local: [
            { name: '蔡欣穆', title: '教授', affiliation: '國立臺灣大學資訊工程學系 副教務長/臺大IoX創新研究中心主任' },
            { name: '林忠緯', title: '副教授', affiliation: '國立臺灣大學資訊工程學系 副系主任' }
        ],
        publicity: [
            { name: '李皇辰', title: '教授', affiliation: '國立中正大學通訊工程學系' },
            { name: '許經國', title: '助理教授', affiliation: '國立中正大學資訊管理學系' }
        ],
        registration: [
            { name: '林奐君', title: '秘書', affiliation: '國立臺灣大學IoX創新研究中心' }
        ],
        web: [
            { name: '程涵寧', title: '研究生', affiliation: '國立臺灣大學資料科學學位學程' },
            { name: '李仁偉', title: '研究生', affiliation: '國立臺灣大學資訊工程學系' },
            { name: '李浩銘', title: '研究生', affiliation: '國立臺灣大學資訊網路與多媒體研究所' }
        ],
        financial: [
            { name: '廖芝勤', title: '助理', affiliation: '國立臺灣大學資訊工程學系' }
        ]
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                    >
                        <h1 className="title">大會組織</h1>
                    </header>

                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle-committee">Honorary Chair</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo([committeeData.honorary])}
                        </div>
                        
                        <h2 className="subtitle-committee">Honorary Vice Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo([committeeData.honoraryVice])}
                        </div>
                        
                        <h2 className="subtitle-committee">Steering Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.steering)}
                        </div>
                        
                        <h2 className="subtitle-committee">General Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.general)}
                        </div>
                        
                        <h2 className="subtitle-committee">Program Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.program)}
                        </div>
                        
                        <h2 className="subtitle-committee">Publication Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.publication)}
                        </div>
                        
                        <h2 className="subtitle-committee">Local Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.local)}
                        </div>
                        
                        <h2 className="subtitle-committee">Publicity Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.publicity)}
                        </div>
                        
                        <h2 className="subtitle-committee">Registration Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.registration)}
                        </div>
                        
                        <h2 className="subtitle-committee">Web Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.web)}
                        </div>
                        
                        <h2 className="subtitle-committee">Financial Chairs</h2>
                        <div className={`subtext ${isMobile ? 'subtext-mobile' : ''}`}>
                            {renderCommitteeInfo(committeeData.financial)}
                        </div>
                    </section>

                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Committee;